import {cloneDeep, isEmpty} from 'lodash';
import {API_RESOURCES, createApiCreateAction, createApiUpdateAction, createApiDeleteAction, createApiReadAction} from '../../common/utils/api';
import {SystemsCodes} from '../../common/utils/uiconstants';
import {normalize} from '../../common/utils/utils';

export const initialState = {
	byId: {},
	allIds: []
};

export const DELETE_PROJECT = 'projects/delete/byId';
export const LEAVE_PROJECT = 'project/users/delete/byId';
export const GET_ALL_PROJECTS = 'projects/get/all';
export const UPDATE_PROJECTS_STORE = 'projects/updateprojectstore';
export const GET_BY_ID_FOR_LANDING_PAGE = 'projects/get/byProjectId';
export const GET_ENGAGEMENT_USERS = 'projects/engagements/users/get';
export const ADD_AD_USERS = 'projects/users/ad/add';
export const REMOVE_AD_USER = 'projects/users/ad/delete';
export const GET_ENGAGEMENT_METADATA = 'projects/engagements/metadata/get/all';
export const CLEAR_ENGAGEMENT_METADATA = 'projects/engagements/metadata/clear';
export const CLEAR_ENGAGEMENT_USERS = 'projects/engagements/users/clear';
export const UPDATE_PROJECT = 'projects/projects/update';
export const POST_BUDGET = 'projects/projects/post';
export const CLEAR_PROJECT = 'projects/projects/clear/byId';
export const CLEAR_ALL_PROJECTS = 'projects/projects/clear/all';
export const GET_ENGAGEMENT_BY_ENGAGEMENTCODE = 'projects/engagements/get/byEngagementCode';
export const CLEAR_RELATEDENGAGEMENT_DATA = 'projects/CLEAR_RELATEDENGAGEMENT_DATA';
export const GET_CANVAS_ENGAGEMENT_DETAIL = 'projects/projects/canvasengagement/get/all';
export const ADD_ENGAGEMENT_CODE_TO_PROJECT = 'projects/projects/addEngagementCodeToProject';
export const UPDATE_ADDED_ENGAGEMENT_CODE = 'projects/projects/updateAddedEngagementCode';
export const REMOVE_ADDED_ENGAGEMENT_CODE = 'projects/projects/removeAddedEngagementCode';
export const ADD_TO_EXISTING_ENGAGEMENT_CODE = 'projects/projects/addToExistingEngagementCode';
export const REMOVE_EXISTING_ENGAGEMENT_CODE = 'projects/projects/removeExistingEngagementCode';
export const RESET_CANVAS_ENGAGEMENT = 'projects/reset/canvasengagement';
export const UPDATE_INDEPENDENCEONLY_TO_EXSISTING_ENGAGEMENT_CODE = 'projects/projects/updateIndependenceOnlyToExistingEngagementCode';
export const UPDATE_INDEPENDENCEONLY_TO_ADDED_ENGAGEMENT_CODE = 'projects/projects/updateIndependenceOnlyToAddedEngagementCode';

export default function reducer(state = initialState, action) {
	state = isEmpty(state) ? initialState : state;
	switch (action.type) {
		case UPDATE_PROJECTS_STORE: {
			const projectId = action.projectId;
			return {
				...state,
				allIds: [...state.allIds.filter((projectId) => projectId !== projectId)],
				byId: {
					...state.byId,
					[projectId]: undefined
				},
				projects: {
					allIds: [...state.projects.allIds.filter((projectId) => projectId !== projectId)],
					byId: {
						...state.projects.byId,
						[projectId]: undefined
					}
				}
			};
		}

		case GET_ALL_PROJECTS: {
			const response = Array.isArray(action.response) && action.response.length > 0 ? action.response : [];

			let copy = {...state};
			copy = normalize(
				response.map((project) => ({
					...project,
					name: project.projectName
				})),
				'projectId'
			);

			return copy;
		}

		case GET_BY_ID_FOR_LANDING_PAGE: {
			const thisProjectId = action.response.projectId;
			if (thisProjectId) {
				// Adding the name property, so the landing page works (case when deeplinking into a project and then going back to the landing page)
				const thisProject = {
					...state.byId[thisProjectId],
					...action.response,
					id: action.response.projectId,
					name: action.response.projectName
				};

				thisProject.clients =
					action.response.clients && action.response.clients.length > 0 ? action.response.clients.map((client) => client.financialClientId) : [];

				thisProject.engagements =
					action.response.canvasEngagements && action.response.canvasEngagements.length > 0
						? action.response.canvasEngagements.map((canvasEngagement) => canvasEngagement.engagementId)
						: [];

				thisProject.normalizedEngagements =
					action.response.canvasEngagements && action.response.canvasEngagements.length > 0
						? normalize(
								action.response.canvasEngagements &&
									action.response.canvasEngagements.map((engagement) => ({
										...engagement
									})),
								'engagementId'
							)
						: [];

				thisProject.financialCodes =
					action.response.financialCodes && action.response.financialCodes.length > 0
						? action.response.financialCodes.map((financialCode) => financialCode.financialEngagementId)
						: [];
				thisProject.financialCodeDetails =
					action.response.financialCodes && action.response.financialCodes.length > 0
						? action.response.financialCodes.map((financialCode) => ({
								financialCode: financialCode.financialEngagementId,
								validatedByUserGUI: financialCode.validatedByUserGUI,
								validatedByUserFirstName: financialCode.validatedByUserFirstName,
								validatedByUserLastName: financialCode.validatedByUserLastName,
								validationDate: financialCode.validationDate,
								financialEngagementName: financialCode.financialEngagementName,
								financialEngagementCode: financialCode.financialEngagementId,
								clientName: financialCode.clientName,
								clientCode: financialCode.financialClientId,
								validatedByUserEmail: financialCode.validatedByUserEmail,
								independenceOnly: financialCode.independenceOnly
							}))
						: [];

				thisProject.users = action.response.users && action.response.users.length > 0 ? action.response.users.map((user) => user.userId) : [];

				thisProject.usersDetails = action.response.users && action.response.users.length > 0 ? cloneDeep(action.response.users) : [];

				thisProject.canvasEngagements = [];

				const newState = {
					byId: {
						...state.byId,
						[thisProjectId]: thisProject
					},
					allIds: state.allIds.includes(thisProjectId) ? [...state.allIds] : [...state.allIds, thisProjectId]
				};

				const copy = {
					...state,
					...newState,
					projects: cloneDeep(newState)
				};

				return copy;
			}
			return state;
		}

		case GET_ENGAGEMENT_METADATA: {
			return {
				...state,
				engagements: normalize(
					action.response.engagementMetadataDetails &&
						action.response.engagementMetadataDetails.map((engagement) => ({
							...engagement,
							system: SystemsCodes.CANVAS
						})),
					'engagementID'
				),
				clients: normalize(
					action.response.engagementMetadataDetails &&
						action.response.engagementMetadataDetails.map((engagement) => ({
							clientCode: engagement.clientCode,
							id: engagement.clientID,
							clientName: engagement.clientName
						}))
				),
				workspaces: normalize(
					action.response.engagementMetadataDetails &&
						action.response.engagementMetadataDetails.map((engagement) => ({
							id: engagement.workspaceID,
							workspaceDescription: engagement.workspaceDescription
						}))
				),
				clientWorkspaces: normalize(
					action.response.engagementMetadataDetails &&
						action.response.engagementMetadataDetails.map((engagement) => ({
							id: `${engagement.clientID}#${engagement.workspaceID}`,
							clientId: engagement.clientID,
							clientName: engagement.clientName,
							workspaceId: engagement.workspaceID,
							workspaceDescription: engagement.workspaceDescription
						}))
				)
			};
		}

		case GET_ENGAGEMENT_USERS: {
			return {
				...state,
				engagements: {
					...state.engagements,
					byId: {
						...state.engagements.byId,
						[action.engagementId]: {
							...state.engagements.byId[action.engagementId],
							users: action.response.engagementMetadataUser.map((user) => user.gui)
						}
					}
				},
				users: normalize(action.response.engagementMetadataUser, 'gui', state.users)
			};
		}

		case ADD_AD_USERS: {
			return {
				...state,
				users: normalize(
					action.users.map((user) => ({
						gui: user.gui,
						addedFirstName: user.firstName,
						addedLastName: user.lastName
					})),
					'gui',
					state.users
				)
			};
		}

		case REMOVE_AD_USER: {
			const user = {...state.users.byId[action.userId]};

			delete user.addedFirstName;
			delete user.addedLastName;

			return {
				...state,
				users: {
					...state.users,
					byId: {
						...state.users.byId,
						[action.userId]: user
					}
				}
			};
		}

		case CLEAR_ENGAGEMENT_USERS: {
			const result = {...state};
			if (result.users) {
				result.engagements = {
					...state.engagements,
					byId: {
						...state.engagements.byId,
						[action.engagementId]: {
							...state.engagements.byId[action.engagementId]
						}
					}
				};

				const users = result.engagements.byId[action.engagementId].users;

				if (users) {
					delete result.engagements.byId[action.engagementId].users;
					result.users = {
						byId: {...state.users.byId},
						allIds: [...state.users.allIds]
					};

					users.forEach((userId) => {
						delete result.users.byId[userId];
						result.users.allIds.splice(result.users.allIds.indexOf(userId), 1);
					});

					if (result.users.allIds.length <= 0) {
						result.users = undefined;
					}
				}

				return result;
			}
			return state;
		}

		case GET_ENGAGEMENT_BY_ENGAGEMENTCODE: {
			let result = state;
			if (!isEmpty(action.response)) {
				result = {...state};
				if (!result.engagements) {
					result.engagements = normalize();
				}

				if (!result.users) {
					result.users = normalize();
				}

				const users = normalize(action.response.users, 'employeeGUI', state.users);

				result = {
					...result,
					engagementCodes: {
						byId: {
							...result.engagementCodes?.byId,
							[action.response.engagementCode]: {
								system: action.system,
								clientCode: action.response.clientCode,
								clientName: action.response.clientName,
								engagementCode: action.response.engagementCode,
								engagementName: action.response.engagementName,
								userGuis: action.response.users.map((user) => user.employeeGUI),
								users: {
									byId: {
										...result.users.byId,
										...users.byId
									},
									allIds: result.users.allIds.concat(users.allIds)
								}
							}
						},
						allIds: result.engagementCodes ? result.engagementCodes.allIds.concat(action.response.engagementCode) : [action.response.engagementCode]
					}
				};
			}
			return result;
		}

		case CLEAR_RELATEDENGAGEMENT_DATA:
			return {};

		case CLEAR_ENGAGEMENT_METADATA:
			return {
				...state,
				engagements: undefined,
				clients: undefined,
				workspaces: undefined,
				clientworkspaces: undefined,
				addedEngagementCodes: undefined
			};

		case UPDATE_PROJECT:
			return {
				...state,
				projects: normalize(
					[
						{
							...action.data,
							id: action.projectId
						}
					],
					undefined,
					state.projects
				)
			};

		case POST_BUDGET:
			if (!isEmpty(action.response)) {
				return {
					...state,
					projects: {
						byId: {
							...state.projects.byId,
							[undefined]: undefined
						},
						allIds: state.projects.allIds.filter((id) => id !== undefined)
					}
				};
			}
			return state;

		case CLEAR_PROJECT: {
			const __state = cloneDeep(state);
			if (__state.projects) {
				if (__state.allIds.length > 0) {
					const projects = {
						byId: cloneDeep(__state.byId),
						allIds: [...__state.allIds]
					};
					__state.projects = projects;
				} else {
					__state.projects = undefined;
				}

				return __state;
			}
			return state;
		}

		case CLEAR_ALL_PROJECTS:
			return {
				...state,
				projects: undefined,
				addedEngagementCodes: undefined
			};

		case GET_CANVAS_ENGAGEMENT_DETAIL:
			if (action.response && !action.response.error) {
				const newState = {
					...state,
					canvasengagement: action.response
				};
				return newState;
			} else {
				return state;
			}

		case RESET_CANVAS_ENGAGEMENT:
			return {...state, canvasengagement: undefined};

		case ADD_ENGAGEMENT_CODE_TO_PROJECT:
			return {
				...state,
				addedEngagementCodes: state.addedEngagementCodes
					? state.addedEngagementCodes.concat({
							engagementCode: action.engagementCode,
							addedUser: action.userId
						})
					: [
							{
								engagementCode: action.engagementCode,
								addedUser: action.userId
							}
						]
			};

		case UPDATE_ADDED_ENGAGEMENT_CODE: {
			const updatedEngagementCodes = state.addedEngagementCodes ? [...state.addedEngagementCodes] : [];
			const index = updatedEngagementCodes.findIndex((element) => element.engagementCode === action.engagementCode);
			updatedEngagementCodes.splice(index, 1, {
				engagementCode: action.engagementCode,
				addedUser: action.userId
			});

			return {
				...state,
				addedEngagementCodes: updatedEngagementCodes
			};
		}
		case REMOVE_ADDED_ENGAGEMENT_CODE: {
			const updatedEngagementCodes = state.addedEngagementCodes ? [...state.addedEngagementCodes] : [];
			const addedEngagementCodes = updatedEngagementCodes.filter((element) => element.engagementCode !== action.engagementCode);
			return {
				...state,
				addedEngagementCodes: addedEngagementCodes
			};
		}

		case ADD_TO_EXISTING_ENGAGEMENT_CODE: {
			const {projectId, engagementCodeInfo, user} = action;
			const thisProject = {
				...state.projects.byId[projectId]
			};

			thisProject.financialCodeDetails = [
				...thisProject.financialCodeDetails,
				{
					financialCode: engagementCodeInfo.engagementCode,
					validatedByUserGUI: user.id,
					validatedByUserFirstName: user.firstName,
					validatedByUserLastName: user.lastName,
					validationDate: new Date(),
					financialEngagementName: engagementCodeInfo.engagementName,
					financialEngagementCode: engagementCodeInfo.engagementCode,
					clientName: engagementCodeInfo.clientName,
					clientCode: engagementCodeInfo.clientCode,
					validatedByUserEmail: user.emailAddress,
					independenceOnly: false
				}
			];

			thisProject.unvalidatedFinancialCodes = thisProject.unvalidatedFinancialCodes.filter((element) => element !== engagementCodeInfo.engagementCode);

			thisProject.financialCodes = [...thisProject.financialCodes, engagementCodeInfo.engagementCode];

			return {
				...state,
				projects: {
					...state.projects,
					byId: {
						...state.projects.byId,
						[projectId]: thisProject
					}
				}
			};
		}

		case REMOVE_EXISTING_ENGAGEMENT_CODE: {
			const thisProject = {
				...state.projects.byId[action.projectId]
			};

			thisProject.financialCodeDetails = thisProject.financialCodeDetails.filter((element) => element.financialCode !== action.engagementCode);

			thisProject.unvalidatedFinancialCodes = thisProject.unvalidatedFinancialCodes.filter((element) => element !== action.engagementCode);

			thisProject.financialCodes = thisProject.financialCodes.filter((financialCode) => financialCode !== action.engagementCode);

			return {
				...state,
				projects: {
					...state.projects,
					byId: {
						...state.projects.byId,
						[action.projectId]: thisProject
					}
				}
			};
		}

		case UPDATE_INDEPENDENCEONLY_TO_EXSISTING_ENGAGEMENT_CODE: {
			const {engagementCode, projectId, independenceOnly} = action;
			const newState = {
				...state.projects.byId[projectId]
			};

			newState.financialCodeDetails = newState.financialCodeDetails.map((element) => {
				if (element.financialCode === engagementCode) {
					return {...element, independenceOnly: independenceOnly};
				}
				return element;
			});

			return {
				...state,
				projects: {
					...state.projects,
					byId: {
						...state.projects.byId,
						[action.projectId]: newState
					}
				}
			};
		}

		case UPDATE_INDEPENDENCEONLY_TO_ADDED_ENGAGEMENT_CODE: {
			const {engagementCode, independenceOnly} = action;

			const updatedEngagementCodes = state.addedEngagementCodes ? [...state.addedEngagementCodes] : [];

			const index = updatedEngagementCodes.findIndex((element) => element.engagementCode === engagementCode);
			updatedEngagementCodes.splice(index, 1, {
				...updatedEngagementCodes[index],
				independenceOnly: independenceOnly
			});

			return {
				...state,
				addedEngagementCodes: updatedEngagementCodes
			};
		}

		default:
			return state;
	}
}

export function getCanvasEngagementDetail(projectId) {
	return createApiReadAction(GET_CANVAS_ENGAGEMENT_DETAIL, {
		projects: projectId + '/CanvasEngagementDetail'
	});
}

export function getProjectInfoForLandingPage(projectId) {
	return createApiReadAction(GET_BY_ID_FOR_LANDING_PAGE, {
		[API_RESOURCES.PROJECTS.PROJECTS]: projectId
	});
}

export function getAllProjects(queryString) {
	return createApiReadAction(GET_ALL_PROJECTS, {projects: undefined}, queryString);
}
export function updateProjectsStore(projectId) {
	return {
		type: UPDATE_PROJECTS_STORE,
		projectId: projectId
	};
}

export function deleteProject(projectId) {
	return createApiDeleteAction(DELETE_PROJECT, {projects: projectId});
}

export function leaveProject(projectId, userId) {
	return createApiDeleteAction(LEAVE_PROJECT, {
		[API_RESOURCES.PROJECTS.PROJECTS]: projectId + '/users/' + userId + '/LeaveProject'
	});
}

export function getEngagementMetadata() {
	return createApiReadAction(GET_ENGAGEMENT_METADATA, {
		engagementMetadata: undefined
	});
}

export function clearEngagementMetadata() {
	return {
		type: CLEAR_ENGAGEMENT_METADATA,
		isOnline: true
	};
}

export function updateProject(data, projectId = undefined) {
	return {
		type: UPDATE_PROJECT,
		projectId,
		data,
		isOnline: true
	};
}

export function postBudget(data) {
	return createApiCreateAction(POST_BUDGET, {[API_RESOURCES.PROJECTS.PROJECTS]: undefined}, data);
}

export function updateBudget(data, projectId) {
	return createApiUpdateAction(UPDATE_PROJECT, {[API_RESOURCES.PROJECTS.PROJECTS]: projectId}, data);
}

export function clearBudget() {
	return {
		type: CLEAR_PROJECT,
		isOnline: true
	};
}

export function clearAllProjects() {
	return {
		type: CLEAR_ALL_PROJECTS
	};
}

export function getEngagementByEngagementCode(engagementCode) {
	return createApiReadAction(
		GET_ENGAGEMENT_BY_ENGAGEMENTCODE,
		{engagements: undefined},
		{
			engagementCode,
			expand: 'users'
		}
	);
}

export function addEngagementCodeToProject(engagementCode, userId) {
	return {
		type: ADD_ENGAGEMENT_CODE_TO_PROJECT,
		engagementCode: engagementCode,
		userId: userId
	};
}

export function updateIndependenceOnlyToExistingEngagementCode(engagementCode, projectId, independenceOnly) {
	return {
		type: UPDATE_INDEPENDENCEONLY_TO_EXSISTING_ENGAGEMENT_CODE,
		engagementCode: engagementCode,
		projectId: projectId,
		independenceOnly: independenceOnly
	};
}

export function updateIndependenceOnlyToAddedEngagementCode(engagementCode, independenceOnly) {
	return {
		type: UPDATE_INDEPENDENCEONLY_TO_ADDED_ENGAGEMENT_CODE,
		engagementCode: engagementCode,
		independenceOnly: independenceOnly
	};
}

export function updateAddedEngagementCode(engagementCode, userId) {
	return {
		type: UPDATE_ADDED_ENGAGEMENT_CODE,
		engagementCode: engagementCode,
		userId: userId
	};
}

export function removeAddedEngagementCode(engagementCode) {
	return {
		type: REMOVE_ADDED_ENGAGEMENT_CODE,
		engagementCode: engagementCode
	};
}

export function getEngagementUsers(engagementId) {
	return createApiReadAction(
		GET_ENGAGEMENT_USERS,
		{
			engagements: engagementId,
			users: undefined
		},
		undefined,
		{engagementId}
	);
}

export function addAdUsers(users) {
	return {
		type: ADD_AD_USERS,
		users
	};
}

export function removeAdUser(userId) {
	return {
		type: REMOVE_AD_USER,
		userId
	};
}

export function clearEngagementUsers(engagementId) {
	return {
		type: CLEAR_ENGAGEMENT_USERS,
		engagementId
	};
}

export function clearRelatedEngagement() {
	return {
		type: CLEAR_RELATEDENGAGEMENT_DATA,
		isOnline: true
	};
}

export function addToExistingEngagementCodes(engagementCodeInfo, projectId, user) {
	return {
		type: ADD_TO_EXISTING_ENGAGEMENT_CODE,
		engagementCodeInfo: engagementCodeInfo,
		projectId: projectId,
		user: user
	};
}

export function removeExistingEngagementCode(engagementCode, projectId) {
	return {
		type: REMOVE_EXISTING_ENGAGEMENT_CODE,
		engagementCode: engagementCode,
		projectId: projectId
	};
}

export function resetCanvasEngagement() {
	return {
		type: RESET_CANVAS_ENGAGEMENT
	};
}
